module.exports = __webpack_public_path__ + "static/media/buy_request_details_make_3.3ca7a65a.png";